import { render } from "./DoltzTermsOfUseText.vue?vue&type=template&id=c97f3efe"
const script = {}

import "./DoltzTermsOfUseText.vue?vue&type=style&index=0&id=c97f3efe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__